export interface Light {
  lateral: LateralPosition;
  lightsEmplacement: Emplacement;
}

export enum LateralPositionEnum {
  left = 'left',
  right = 'right',
  both = 'both',
}
export type LateralPosition = `${LateralPositionEnum}`;

export enum EmplacementEnum {
  front = 'front',
  rear = 'rear',
}
export type Emplacement = `${EmplacementEnum}`;
